import { getBezierPath } from '@xyflow/react';

export const WidgetEdge = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition }) => {
  const [edgePath] = getBezierPath({
    sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition,
  });

  return (
    <path
      id={id}
      d={edgePath}
      fill="none"
      stroke="hsl(var(--chart-1))"
      strokeWidth={1}
      strokeDasharray="4 4"
      strokeOpacity={0.3}
    />
  );
};
